import { lazy, Suspense } from 'react';

import { DataProvider } from '@/data/provider';
import { RouterProvider } from '@/router/RouterProvider';
import ErrorBoundary from './ErrorBoundary';
import LoadingScreen from './components/LoadingScreen';
import { ConsentPopup } from './consent';
import { ScrollPosProvider } from './scrollLock/context';

const PageWrap = lazy(() => import('./views/PageWrap'));

const App = () => {
	return (
		<DataProvider>
			<ScrollPosProvider>
				<ErrorBoundary>
					<RouterProvider>
						<Suspense fallback={<LoadingScreen />}>
							<PageWrap />
						</Suspense>
					</RouterProvider>
					<ConsentPopup />
				</ErrorBoundary>
			</ScrollPosProvider>
		</DataProvider>
	);
};

export default App;
